/* istanbul ignore file */

export { Page as default } from "./Page";
